module.exports = __webpack_public_path__ + "img/系统及配置.26a2ebc6.jpg";